module.exports = __webpack_public_path__ + "img/lynn.8b525bec.png";